import React from 'react';
export const ProductIntroSection = () => {
  const bullets = ['Actividades físicas y cognitivas organizadas por nivel.', 'Guía clara para familiares, cuidadores y profesionales.', 'Registros y herramientas prácticas para ordenar el cuidado diario.'];
  return <section className="bg-familia-bg py-10 md:py-16 px-4 md:px-6" data-id="element-171">
      <div className="max-w-5xl mx-auto text-center w-[92%] md:w-full" data-id="element-172">
        <div className="inline-block bg-familia-cyan text-familia-bg font-bold text-xs sm:text-sm px-4 sm:px-6 py-2 rounded-full mb-6 md:mb-8 uppercase tracking-wider" data-id="element-173">
          📚 Un sistema completo de bienestar, estimulación y organización para
          adultos mayores
        </div>
        <h2 className="text-4xl sm:text-6xl md:text-7xl font-display font-bold mb-2" data-id="element-174">
          VITALIDAD 360™
        </h2>

        <p className="text-familia-gray text-[15px] md:text-xl max-w-3xl mx-auto mb-8 md:mb-12 leading-relaxed" data-id="element-175">
          📚 Vitalidad 360™ reúne en un solo kit actividades cognitivas,
          ejercicios de movilidad, registros de salud, guía para cuidadores y
          bonos prácticos para acompañar adultos mayores en casa.
        </p>
        <div className="bg-familia-card border border-familia-cyan/15 p-6 md:p-12 rounded-3xl mb-10 md:mb-16" data-id="element-176">
          <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 text-left max-w-3xl mx-auto" data-id="element-177">
            {bullets.map((b, i) => <div key={i} className="flex items-center gap-3" data-id="element-178">
                <span className="text-familia-green text-xl" data-id="element-179">✅</span>
                <span className="font-bold text-[15px] sm:text-base" data-id="element-180">{b}</span>
              </div>)}
          </div>
        </div>
      </div>
    </section>;
};